let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6bLCw")).then(() => parcelRequire('6q8dO'));